import { SET_LOGOUT, CLEAR_ALL } from '../../../store/Types';

export const GETALL_TIPOS_CLASES = 'GETALL_TIPOS_CLASES';
export const ACTIVO_TIPOS_CLASES = 'ACTIVO_TIPOS_CLASES';
export const LOADING_GETALL_TIPOS_CLASES = 'LOADING_GETALL_TIPOS_CLASES';
export const PARAMS_TIPOS_CLASES = 'PARAMS_TIPOS_CLASES';

const initialState = {
  all: [],
  activo: null,
  loadingGetAll: false,
  params: {},
};

export const tiposClasesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_TIPOS_CLASES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case ACTIVO_TIPOS_CLASES:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_GETALL_TIPOS_CLASES:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_TIPOS_CLASES:
      return {
        ...state,
        params: action.payload,
      };
    case SET_LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
